import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from "@angular/common";
import { MatButton, MatFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'main-action',
  providers: [],
  styleUrls: ['./main-action.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatFabButton,
    MatTooltip,
    TranslateModule,
    MatIcon,
    MatProgressSpinner,
    MatButton
  ],
  templateUrl: './main-action.html'
})
export class MainActionComponent implements AfterViewInit {
    @Input() public displayMode = 'fab';
    @Input() public isLoading = false;
    @Input() public title = '';
    @Input() public icon: string | null = null;
    @Input() public disabled = false;
    @Output() public onAction: EventEmitter<any> = new EventEmitter<any>();
    @Input() public link: string | null = null;
    @Input() public right = 32;
    @Input() public bottom = 16;
    @Input() public color = 'accent';
    constructor(
        private _router: Router,
        private _translater: TranslateService
    ) { }

    public ngAfterViewInit() {

    }

    public onClicked(): void {
        if (this.link) {
            this._router.navigateByUrl(this.link);
        }

        this.onAction.emit();
    }
}
